"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemperatureContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TemperatureContainerModule = _interopRequireDefault(require("../../styles/components/TemperatureContainer.module.css"));
var _arrow_left = _interopRequireDefault(require("../../icons/arrow_left.svg"));
var _TemperatureBoxSmall = require("./_TemperatureBoxSmall");
var _hooks = require("../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const {
  SectionTypes,
  LoopType
} = _paulCorePackage.constants;
const TemperatureContainer = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    thingPDIDDeviceList = []
  } = _ref;
  const devices = (0, _hooks.useGetDevicesByPdid)(thingPDIDDeviceList);
  const getDevice = _ref2 => {
    let {
      sectionType,
      loopType
    } = _ref2;
    return devices.find(device => {
      var _device$thingLoopType, _device$thingSectionT;
      return Number((_device$thingLoopType = device.thingLoopType) === null || _device$thingLoopType === void 0 ? void 0 : _device$thingLoopType.id) === loopType && Number((_device$thingSectionT = device.thingSectionType) === null || _device$thingSectionT === void 0 ? void 0 : _device$thingSectionT.id) === sectionType;
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _TemperatureContainerModule.default.wrapper
  }, /*#__PURE__*/_react.default.createElement("span", null, "Secondary"), /*#__PURE__*/_react.default.createElement("div", {
    className: _TemperatureContainerModule.default.arrow
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _arrow_left.default,
    alt: "Arrow Left"
  })), /*#__PURE__*/_react.default.createElement("span", null, "Primary"), /*#__PURE__*/_react.default.createElement(_TemperatureBoxSmall.TemperatureBoxSmall, {
    device: getDevice({
      sectionType: SectionTypes.flow,
      loopType: LoopType.secondary
    })
  }), /*#__PURE__*/_react.default.createElement(_TemperatureBoxSmall.TemperatureBoxSmall, {
    device: getDevice({
      sectionType: SectionTypes.flow,
      loopType: LoopType.primary
    })
  }), /*#__PURE__*/_react.default.createElement(_TemperatureBoxSmall.TemperatureBoxSmall, {
    device: getDevice({
      sectionType: SectionTypes.return,
      loopType: LoopType.secondary
    })
  }), /*#__PURE__*/_react.default.createElement(_TemperatureBoxSmall.TemperatureBoxSmall, {
    device: getDevice({
      sectionType: SectionTypes.return,
      loopType: LoopType.priority
    })
  }));
});
exports.TemperatureContainer = TemperatureContainer;
TemperatureContainer.propTypes = {
  thingPDIDDeviceList: _propTypes.default.arrayOf(_propTypes.default.string)
};